export const useConvertUsd = (price: Nullable<number | string>) => {
  const numberFormat = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  return price ? numberFormat.format(Number(price) / 3.69) : 0 
}